import { Box, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

type StepShellProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

const StepShell = ({ title, subtitle, children }: StepShellProps) => (
  <Box>
    <Text
      fontSize={{ base: 'xl', md: '2xl' }}
      fontWeight="800"
      color="leaseEndBlue"
      lineHeight="1.2"
    >
      {title}
    </Text>
    {subtitle && (
      <Text fontSize="sm" color="grayLight" mt={2} lineHeight="1.5">
        {subtitle}
      </Text>
    )}
    <Box mt={6}>{children}</Box>
  </Box>
);

export default StepShell;
